import { FC } from "react";

interface IGiftshopConfirmationHeaderProps {}

const GiftshopConfirmationHeader: FC<IGiftshopConfirmationHeaderProps> = () => {
  return (
    <h4 className="modal-title my-3 mx-3 giftshop-confirmation-header">
      Thank you for purchasing a gift with us!
    </h4>
  );
};

export default GiftshopConfirmationHeader;
